import { OutrightMarket, SportMatchModel } from '@nf/types/odds';
import { useMemo } from 'react';
import { getHomeTeamName, getTeamName } from '@/utils/odds-utils';
import { useAtomValue } from 'jotai';
import { oddsPageAtom } from '@/atoms/odds-page';
import { matchEquals } from '@nf/utils-common/fpw/monadic';
import { OutrightListItemContent } from './outright-list-item-content';
import { ListItemContent } from './list-item-content';
import { useTranslations } from 'next-intl';
import { useSiteStore } from '@/store/site';
import { useMatchBetTypes } from '../../hooks/use-match-bet-types';
import { ListMatchOption } from './list-match-option';
import { useGetBetTypeSetting } from '@/hooks';

interface ListItemProps {
    match: SportMatchModel;
    isLeagueExpand: boolean;
	sportId: number;
}
export const ListItem = ({ match, isLeagueExpand, sportId }: ListItemProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();
	const betTypeFilterCriterion = useSiteStore((state) => state.getBetTypeFilterCriterion(sportId));
	const betTypeSetting = useMemo(() => getBetTypeSetting((betTypeFilterCriterion && Array.isArray(betTypeFilterCriterion.betTypes)) ? betTypeFilterCriterion.betTypes[0] : 0, sportId), [betTypeFilterCriterion]);
	const oddsData = useAtomValue(oddsPageAtom);
	const t = useTranslations('General');

	const { markets, hasGetMarket } = useMatchBetTypes({
		match: match,
		isFetchFromGetMarket: isLeagueExpand,
		sportId: sportId,
		betTypeClass: 'OU'
	});
	
	return (
		<>
			{
				(isLeagueExpand || hasGetMarket) && matchEquals(sportId)
					.on(999, () => (
						<OutrightListItemContent
							match={match}
							markets={markets as OutrightMarket[]}
							teamNameMap={oddsData?.teamNameMap}
							isLoading={!hasGetMarket}
						/>
					))
					.otherwise(() => betTypeSetting && (
						<div
							key={match.MatchId}
							className="match"
						>
							<ListItemContent
								sport={sportId}
								match={match}
								markets={markets}
								isLoading={!hasGetMarket}
								homeTeamName={getHomeTeamName(match.TeamId1, match.Neu, t('Neutral_Team'), oddsData?.teamNameMap)}
								awayTeamName={getTeamName(match.TeamId2, oddsData?.teamNameMap)}
								betTypeSetting={betTypeSetting}
								betTypeFilterCriterion={betTypeFilterCriterion}
							/>
							<ListMatchOption match={match} />
						</div>
					))
			}
		</>
	)
}